import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { fetchAnalyticsChartData } from "../../../config/service";
import ChartLoader from "./Loading";

const DropOffChart = ({
  utm,
  toDate,
  fromDate,
  isLoader,
  setIsLoader,
  activeTab,
}) => {
  const [data, setData] = useState(null);

 useEffect(() => {
   const bothDatesSelected = fromDate && toDate;
   const noDatesSelected = !fromDate && !toDate;
   if (!bothDatesSelected && !noDatesSelected) return;
   handleFetchData();
 }, [utm, toDate, activeTab, fromDate]);

  const handleFetchData = async () => {
    try {
      setIsLoader(true);
      const response = await fetchAnalyticsChartData({
        type: "dropoff",
        utm,
        fromDate,
        toDate,
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching drop-off data:", error);
    } finally {
      setIsLoader(false);
    }
  };

  if (isLoader || !data) return <ChartLoader isLoader={isLoader} />;
  if (!isLoader && (!data || data.length === 0))
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <h4>No data available</h4>
      </div>
    );

  const options = {
    chart: { type: "bar" },
    xaxis: {
      categories: data?.map((s) => `Step ${s.stepNumber}`),
    },
  };

  const series = [
    {
      name: "Users Dropped",
      data: data.map((s) => s.count),
    },
  ];

  return <Chart options={options} series={series} type="bar" height={400} />;
};

export default DropOffChart;
